(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/params-fullscreen.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/params-fullscreen.js');

'use strict';

const ParamsFullscreen = () => React.createElement("div", {
  className: "lp-fullscreen-overlay"
}, React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "54",
  height: "80",
  viewBox: "0 0 54 80",
  fill: "none"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.333374 26.764C0.333374 11.5017 11.8379 0 27 0V0.00415163C42.0584 0.00415163 53.6667 11.5059 53.6667 26.7681C53.6667 33.1188 51.2963 38.0362 48.2196 43.2673C45.143 48.4985 27 80 27 80C27 80 8.61371 47.9645 5.69745 43.1968C2.78119 38.429 0.333374 33.0855 0.333374 26.764ZM10.7487 22.9781C10.7487 18.5127 14.4089 14.9257 18.8743 14.9257C23.3398 14.9257 27 19.7938 27 19.7938C27 19.7938 30.6602 14.9257 35.1257 14.9257C39.6278 14.9257 43.2514 18.5493 43.2514 22.9781C43.2514 26.5652 41.8239 35.0934 27.8053 43.7316C27.5491 43.878 26.9635 44.244 26.9635 44.244C26.9635 44.244 26.3778 43.878 26.1216 43.7316C12.1761 35.0934 10.7487 26.5652 10.7487 22.9781Z",
  fill: "#16FFAB"
})), React.createElement("div", {
  className: "fullscreen-header"
}, "Fullsk\xE4rmsl\xE4ge ", React.createElement("span", null, "Med auto-play om:")), React.createElement("div", {
  className: "seconds"
}, React.createElement("span", null, " s")));
setGlobal('svs.lyckoplatsen.components.page_result.react.components', {
  ParamsFullscreen
});

 })(window);